/* ET Cart Drawer — Swiper sliders, upgrade variant-swap toggle, upsell add.
   The drawer body (.drawer__inner / #CartDrawer) is replaced on every cart
   update via the Section Rendering API, so sliders are re-initialised through
   a MutationObserver and all clicks are delegated to document. */
(function () {
  'use strict';

  var ROUTES = window.routes || {};
  var ADD_URL = (ROUTES.cart_add_url || '/cart/add') + '.js';
  var CHANGE_URL = (ROUTES.cart_change_url || '/cart/change') + '.js';
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  /* ---------- Swiper ---------- */

  function initUspSwiper() {
    var wrap = document.querySelector('[data-et-usp]');
    if (!wrap) return;
    var el = wrap.querySelector('[data-et-usp-swiper]');
    if (!el || el.swiper) return;
    var slides = el.querySelectorAll('.swiper-slide').length;
    new window.Swiper(el, {
      loop: slides > 1,
      allowTouchMove: slides > 1,
      autoplay: slides > 1 ? { delay: 4500, disableOnInteraction: false } : false,
      speed: 400,
      navigation: {
        prevEl: wrap.querySelector('[data-et-usp-prev]'),
        nextEl: wrap.querySelector('[data-et-usp-next]')
      }
    });
  }

  function initUpsellSwiper() {
    var el = document.querySelector('[data-et-upsell-swiper]');
    if (!el || el.swiper) return;
    var section = el.closest('.et-cdr__section--upsell');
    new window.Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 10,
      noSwipingSelector: 'select, button, input, textarea',
      pagination: {
        el: section ? section.querySelector('[data-et-upsell-pagination]') : null,
        clickable: true
      }
    });
  }

  var initQueued = false;
  function queueInit() {
    if (initQueued || !window.Swiper) return;
    initQueued = true;
    requestAnimationFrame(function () {
      initQueued = false;
      initUspSwiper();
      initUpsellSwiper();
    });
  }

  var swiperTries = 0;
  function waitForSwiper() {
    if (window.Swiper) {
      queueInit();
      return;
    }
    if (swiperTries++ < 40) setTimeout(waitForSwiper, 250);
  }

  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__etCdrObserved) return;
    drawer.__etCdrObserved = true;
    new MutationObserver(function () {
      queueInit();
      loadCartUpsells();
    }).observe(drawer, { childList: true, subtree: true });
  }

  /* ---------- Automatic upsells (Shopify product recommendations) ----------
     Fetches sections/et-cart-upsells.liquid through the recommendations
     endpoint for the newest cart item and swaps the slides into the drawer.
     Intent chain: complementary → related → keep the server-rendered
     fallback list (or stay hidden when that is empty too). */

  var upsellRecsCache = {};
  var upsellRecsPending = {};

  function loadCartUpsells() {
    var wrap = document.querySelector('[data-et-upsell-source]');
    if (!wrap) return;

    var productId = wrap.getAttribute('data-et-first-product');
    if (!productId) return;
    if (wrap.getAttribute('data-et-recs-applied') === productId) return;
    if (upsellRecsPending[productId]) return;

    var cached = upsellRecsCache[productId];
    if (cached !== undefined) {
      if (cached) {
        applyRecommendedUpsells(wrap, productId, cached);
      } else {
        wrap.setAttribute('data-et-recs-applied', productId);
      }
      return;
    }

    var base = wrap.getAttribute('data-et-recs-url') || '/recommendations/products';
    var limit = parseInt(wrap.getAttribute('data-et-recs-limit'), 10) || 8;
    upsellRecsPending[productId] = true;

    fetchRecs('complementary');

    function fetchRecs(intent) {
      fetch(base + '?section_id=et-cart-upsells&product_id=' + productId + '&limit=' + limit + '&intent=' + intent)
        .then(function (res) {
          return res.ok ? res.text() : '';
        })
        .then(function (html) {
          var slides = extractUpsellSlides(html);
          if (slides) {
            upsellRecsCache[productId] = slides;
            delete upsellRecsPending[productId];
            applyRecommendedUpsells(wrap, productId, slides);
          } else if (intent === 'complementary') {
            fetchRecs('related');
          } else {
            upsellRecsCache[productId] = '';
            delete upsellRecsPending[productId];
            var current = document.querySelector('[data-et-upsell-source]');
            if (current) current.setAttribute('data-et-recs-applied', productId);
          }
        })
        .catch(function (err) {
          delete upsellRecsPending[productId];
          console.error('[et-cart-drawer] recommendations failed', err);
        });
    }
  }

  function extractUpsellSlides(html) {
    if (!html) return '';
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var slides = doc.querySelectorAll('.et-cdr__upsell-slide');
    if (!slides.length) return '';
    var out = '';
    for (var i = 0; i < slides.length; i++) out += slides[i].outerHTML;
    return out;
  }

  function applyRecommendedUpsells(wrap, productId, slidesHTML) {
    /* Re-query: the drawer may have re-rendered while the fetch was running */
    var current = document.querySelector('[data-et-upsell-source]');
    if (!current) return;
    var swiperEl = current.querySelector('[data-et-upsell-swiper]');
    var wrapper = swiperEl && swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
    wrapper.innerHTML = slidesHTML;
    current.classList.remove('is-empty');
    current.setAttribute('data-et-recs-applied', productId);
    queueInit();
  }

  /* ---------- Cart requests ---------- */

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw json;
        return json;
      });
    });
  }

  function refreshDrawer(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && state && state.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
      drawer.classList.remove('is-empty');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'et-cart-drawer', cartData: state });
      }
    } else {
      window.location.reload();
    }
  }

  /* ---------- Upgrade toggle (variant swap, same idea as ET PDP) ---------- */

  function handleUpgradeToggle(btn) {
    if (btn.classList.contains('is-loading')) return;
    var lineKey = btn.getAttribute('data-line-key');
    var targetVariant = parseInt(btn.getAttribute('data-target-variant'), 10);
    var quantity = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
    if (!lineKey || !targetVariant) return;

    btn.classList.add('is-loading');
    btn.classList.toggle('is-on');
    btn.setAttribute('aria-checked', btn.classList.contains('is-on') ? 'true' : 'false');

    /* Preserve line item properties and selling plan across the swap */
    var addItem = { id: targetVariant, quantity: quantity };
    var propsRaw = btn.getAttribute('data-line-properties');
    if (propsRaw) {
      try {
        var props = JSON.parse(propsRaw);
        if (props && typeof props === 'object' && Object.keys(props).length) {
          addItem.properties = props;
        }
      } catch (e) {
        /* malformed JSON — swap without properties */
      }
    }
    var sellingPlan = parseInt(btn.getAttribute('data-selling-plan'), 10);
    if (sellingPlan) addItem.selling_plan = sellingPlan;

    postJSON(ADD_URL, { items: [addItem] })
      .then(function () {
        return postJSON(CHANGE_URL, {
          id: lineKey,
          quantity: 0,
          sections: SECTIONS,
          sections_url: window.location.pathname
        });
      })
      .then(refreshDrawer)
      .catch(function (err) {
        console.error('[et-cart-drawer] upgrade swap failed', err);
        btn.classList.remove('is-loading');
        btn.classList.toggle('is-on');
        btn.setAttribute('aria-checked', btn.classList.contains('is-on') ? 'true' : 'false');
      });
  }

  /* ---------- Upsell add ---------- */

  function handleUpsellAdd(btn) {
    if (btn.classList.contains('is-loading')) return;
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    btn.classList.add('is-loading');

    postJSON(ADD_URL, {
      items: [{ id: variantId, quantity: 1 }],
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
      .then(refreshDrawer)
      .catch(function (err) {
        console.error('[et-cart-drawer] upsell add failed', err);
        btn.classList.remove('is-loading');
        /* 422 = variant became unavailable after render (sold out meanwhile):
           disable the button instead of leaving a dead retry loop. */
        if (err && err.status === 422) {
          btn.disabled = true;
          btn.classList.add('is-disabled');
        }
      });
  }

  /* ---------- Delegated events ---------- */

  /* Upsell variant selector: retarget the add button + update prices */
  document.addEventListener('change', function (event) {
    var select = event.target && event.target.closest
      ? event.target.closest('[data-et-upsell-variant-select]')
      : null;
    if (!select) return;

    var card = select.closest('.et-cdr__upsell-card');
    if (!card) return;

    var option = select.options[select.selectedIndex];
    var btn = card.querySelector('[data-et-upsell-add]');
    if (btn) {
      btn.setAttribute('data-variant-id', select.value);
      btn.disabled = false;
      btn.classList.remove('is-disabled');
    }

    var priceEl = card.querySelector('[data-et-upsell-price]');
    if (priceEl && option && option.getAttribute('data-price')) {
      priceEl.textContent = option.getAttribute('data-price');
    }

    var compareEl = card.querySelector('[data-et-upsell-compare]');
    if (compareEl && option) {
      var compare = option.getAttribute('data-compare');
      if (compare) {
        compareEl.textContent = compare;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var toggle = target.closest('[data-et-upgrade-toggle]');
    if (toggle) {
      event.preventDefault();
      handleUpgradeToggle(toggle);
      return;
    }

    var addBtn = target.closest('[data-et-upsell-add]');
    if (addBtn) {
      event.preventDefault();
      handleUpsellAdd(addBtn);
    }
  });

  function boot() {
    observeDrawer();
    waitForSwiper();
    loadCartUpsells();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
